var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearningPath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3058 7.37075C13.3085 4.23107 10.9531 1.59174 7.83739 1.24284C4.72165 0.893949 1.8422 2.94701 1.15178 6.00946C0.461737 9.07228 2.18196 12.1645 5.14531 13.1893V17.8007H9.16179V13.189C10.371 12.7712 11.42 11.9862 12.1628 10.9434C12.9055 9.90052 13.3051 8.65169 13.3058 7.37075V7.37075Z",
    stroke: "#43ADE8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50781 14.9263H9.85622V17.017H4.50781V14.9263Z",
    stroke: "#43ADE8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningPath);
export default __webpack_public_path__ + "static/media/learning_path.3fed04565cc779d268f12c30b87db23d.svg";
export { ForwardRef as ReactComponent };